import { Box, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SwipeDownIcon from '../../../common/SwipeDownIcon';
import AnimatedTypography from '../../../core/AnimatedTypography';


interface LandingProps {
}

const Landing: React.FC<LandingProps> = ({ }) => {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                marginTop: { xs: "-56px", sm: "-64px" },
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/gallery/full/${4}.jpg)`,
                backgroundPosition: { xs: "center top", md: "center" },
                backgroundSize: "cover",
                position: "relative",
                // zIndex: 3,
                "&::before": {
                    background: "rgb(11, 11, 11)",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 1,
                    content: '""',
                    opacity: .55
                }
            }}
            pl={0}
            pr={0}
            width={"100vw"}
            minHeight={"100svh"}
            marginLeft={"calc(50% - 50vw)"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}>
            <Grid
                pt={{ xs: "calc(56px + 2rem)", sm: "calc(64px + 3rem)" }}
                pb={{ xs: 5, sm: 6 }}
                zIndex={10}
                container
                justifyContent={"flex-start"}>
                <Container maxWidth="xl">
                    <Box
                        display={"flex"}
                        flexDirection={{ xs: "column", md: "row" }}
                        alignItems={{ xs: "flex-start", md: "center" }}
                        gap={{ xs: 0, md: 6, lg: 10 }}>
                        <Box maxWidth={760} flex={1}>
                            <AnimatedTypography color={"#eef0f5ff"} variant='h1' lineHeight={1.1} fontWeight={600}
                                sx={{
                                    fontSize: { xs: "3.25rem", sm: "4.2rem", md: "5rem", lg: "5.7rem" },
                                    textShadow: "#000000ff 1px 0 10px"
                                }}>
                                <Trans
                                    i18nKey="aboutUs.basic.title"
                                    components={{
                                        highlight: <Typography component="span" color="primary.main" fontWeight={700} fontStyle={"italic"} sx={{ fontSize: "inherit", lineHeight: "inherit" }} />
                                    }}>
                                </Trans>
                            </AnimatedTypography>
                            <Box mt={4} mb={{ xs: 0, md: 4 }} maxWidth={700}>
                                <AnimatedTypography color={"#d6d8e0ff"} fontWeight={600} variant='h6' sx={{ textShadow: "#000000ff 1px 0 10px" }}>
                                    {t("aboutUs.basic.row1")}
                                </AnimatedTypography>

                                <AnimatedTypography mt={2} color={"#d6d8e0ff"} fontWeight={600} variant='h6' sx={{ textShadow: "#000000ff 1px 0 10px" }}>
                                    <Trans
                                        i18nKey="aboutUs.basic.row2"
                                        components={{
                                            highlight: <Typography component="span" color="primary.main" fontWeight={700} fontStyle={"italic"} sx={{ textShadow: "#000000ff 1px 0 10px" }} />
                                        }}>
                                    </Trans>
                                </AnimatedTypography>
                            </Box>
                        </Box>
                        {/* <Box
                            mt={{ xs: 4, md: 12 }}
                            px={{ xs: 2, sm: 3 }}
                            py={{ xs: 2, sm: 2.5 }}
                            width={{ xs: "100%", md: 440, lg: 500 }}
                            flexShrink={0}
                            borderRadius={1}
                            border={"1px solid"}
                            borderColor={"primary.main"}
                            sx={{
                                backgroundColor: "rgba(0, 0, 0, 0.45)",
                                boxShadow: "0 0 18px rgba(255, 94, 20, 0.28)"
                            }}>
                            <AnimatedTypography color={"#eef0f5ff"} fontWeight={700} variant='h6' sx={{ textShadow: "#000000ff 1px 0 10px" }}>
                                <Trans
                                    i18nKey="aboutUs.basic.groupDiscount"
                                    components={{
                                        highlight: <Typography component="span" color="primary.main" fontWeight={800} fontStyle={"italic"} sx={{ fontSize: { xs: "1.55rem", sm: "1.8rem" }, textShadow: "#000000ff 1px 0 10px" }} />
                                    }}>
                                </Trans>
                            </AnimatedTypography>
                        </Box> */}
                    </Box>
                </Container>
            </Grid>
            <SwipeDownIcon />
        </Box>
    )
}

export default Landing;